// src/constants/yoloModels.js
// Shared YOLO model type options — used by the new-upload parameters modal
// (PhotoProcessingPage.js) and the reprocess parameters modal
// (ReprocessJobModal.jsx). Keep both in sync with the model types accepted
// by the Triton backend (photo_processing.triton_client).
export const yoloModelOptions = [
  { value: 0, label: 'Auto', description: 'Automatically select the best model' },
  { value: 1, label: 'Universal', description: 'General-purpose model for most chemical plate types' },
  { value: 2, label: 'IR', description: 'Optimized for infrared spectroscopy plates' },
  { value: 3, label: '254&366', description: 'Specialized for 254nm and 366nm UV spectroscopy plates' }
];

export const getYoloModelLabel = (value) => {
  const option = yoloModelOptions.find(opt => opt.value === value);
  return option ? option.label : 'Unknown';
};
